import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import IconRing from "../subcomponents/IconRing";

import DisabledPlus from "../../../../../../assets/icons/Icon - Add - Disabled.svg";
import CompleteTaskIcon from "../../../../../../assets/icons/Icon-Complete-Task-Green-20.svg";
import CancelTaskIcon from "../../../../../../assets/icons/Icon-Cancel-Task-Red-20.svg";
import RequestReviewIcon from "../../../../../../assets/icons/Icon-Request-Review-Blue-20.svg";
import ApproveTaskIcon from "../../../../../../assets/icons/Icon-Approve-Task-Green-20.svg";
import DeclineTaskIcon from "../../../../../../assets/icons/Icon-Decline-Task-Red-20.svg";

// Same rules as BaseActionRow: "task"/"tasks" optional, case-insensitive.
const ACTION_ICON_RULES = [
  { re: /^\s*complete(?:\s+tasks?)?\s*$/i, icon: CompleteTaskIcon, alt: "Complete Task" },
  { re: /^\s*cancel(?:\s+tasks?)?\s*$/i, icon: CancelTaskIcon, alt: "Cancel Task" },
  { re: /^\s*request\s*review(?:\s+tasks?)?\s*$/i, icon: RequestReviewIcon, alt: "Request Review" },
  { re: /^\s*approve(?:\s+tasks?)?\s*$/i, icon: ApproveTaskIcon, alt: "Approve Task" },
  { re: /^\s*(?:decline|reject)(?:\s+tasks?)?\s*$/i, icon: DeclineTaskIcon, alt: "Decline Task" },
];

const getIconForAction = (name) => {
  if (!name || typeof name !== "string") {
    return { src: DisabledPlus, alt: "Base Action" };
  }
  const rule = ACTION_ICON_RULES.find(({ re }) => re.test(name));
  return rule ? { src: rule.icon, alt: rule.alt } : { src: DisabledPlus, alt: "Base Action" };
};

const HiddenBaseActionsRow = ({ field, index, onUnhide }) => {
  const { src: actionIcon, alt: actionAlt } = useMemo(
    () => getIconForAction(field?.Name),
    [field?.Name]
  );

  return (
    <div className="individual-workflow" id={`workflowstatusBase_${index}`}>
      <div className="individual-workflow-status hidden-base-status">
        <IconRing src={actionIcon} alt={`${actionAlt} (hidden)`} iconSize={16} padding={10} />
        <span className="status-index"></span>
        <div className="field-container-base pl-2">{field?.Name}</div>

        <OverlayTrigger
          placement="top"
          delay={{ show: 150, hide: 150 }}
          overlay={
            <Tooltip id={`unhide-tooltip-${field?.Id ?? index}`}>
              Click to unhide
            </Tooltip>
          }
        >
          <Button
            className="btn-icon1 unhide-eye-icon"
            onClick={() => onUnhide(field.Id, field?.IsHidden)}
            type="button"
            aria-label="Unhide action"
          />
        </OverlayTrigger>
      </div>
    </div>
  );
};

HiddenBaseActionsRow.propTypes = {
  field: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    Name: PropTypes.string.isRequired,
    IsHidden: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onUnhide: PropTypes.func.isRequired,
};

export default HiddenBaseActionsRow;
